const websocket = {
  data: () => {
    return {
      msg: '',
      descontos: [],
      teto_tipos: [],
      connection: null,
    }
  },

  computed: {
    websocket: function (url) {
      return new WebSocket(url);
    }
  },

  async beforeDestroy() {
    if (this.connection) {
      this.connection.onclose();
    }
  },

  methods: {
    connect: function (bancaId, eventId, url) {
    //   const BLOCK_WEBSOCKET_DEV = bancaId == 659;

    //   if (BLOCK_WEBSOCKET_DEV) {
    //     return;
    //   }

      window.WebSocket = window.WebSocket || window.MozWebSocket;
      if (!window.WebSocket) return

      const _this = this;
      this.connection = new WebSocket(url);

      // Open connection Websocket
      this.connection.onopen = function (e) {
        const msg = eventId == null ?
          `{"action": "sendMessage",  "id_banca": "${bancaId}"}` :
          `{"id_banca_evento": "${bancaId}-${eventId}", "id_evento": "${eventId}"}`
        if (_this.connection.readyState === 1) {
          _this.sendMessage(msg)
        }
      };

      // Get messages from Websocket  
      this.connection.onmessage = function (message) {

        const msg = JSON.parse(message.data);
        if (msg.type == 'odds') {
          _this.type_odds(msg, url)
        }

        if (msg.type == 'descontos') {
          _this.descontos = msg.data;
        }
      },

        this.connection.onclose = function (evt) {
          _this.finishConnection(evt);
        }
    },

    sendMessage: function (msg) {
      this.connection.send(msg);
    },

    finishConnection: function (evt) {
      this.connection.close(1000);
    },

    type_odds: function (msg, url) {
      const {
        data,
        scores
      } = msg;

      if (url === 'wss://ws.sga.bet') {
        this.scores = scores;
        this.data_events_live = data;
      }

      if (url === 'wss://wsh.sga.bet' || url === 'wss://wss.sga.bet') {
        this.events_live = data.sports;
      }


    },
  }
}

export default websocket;